import useToggle from "../frontend/hooks/useToggle";
import MenuSearchForm from "../MenuSearchForm/MenuSearchForm";
//import menu, { TMenuItem } from '../frontend/data/main-menu';

interface TMenuItem {
  label: string;
  url?: string;
  children?: TMenuItem[];
}

interface MenuProps {
  menu: TMenuItem[];
  homeUrl: string;
}

const MainMenu: React.FC<MenuProps> = ({ menu, homeUrl }) => {
  return (
    <div className="main-menu">
      <nav>
        <MenuSearchForm homeUrl={homeUrl} />
        <ul>
          {menu.map((item, idx) => (
            <MenuItem key={idx} item={item} />
          ))}
        </ul>
      </nav>
    </div>
  );
};

function MenuItem({ item }: { item: TMenuItem }) {
  const [open, toggle] = useToggle();
  const hasChildren = !!item.children?.length;
  return (
    <li className={open ? "open" : undefined}>
      <div>
        {!item.url ? (
          <span>{item.label}</span>
        ) : (
          <a href={item.url}>{item.label}</a>
        )}
        {hasChildren && (
          <button aria-label="Toggle sub-menu" onClick={toggle} />
        )}
      </div>
      {hasChildren && (
        <ul>
          {item.children!.map((child, idx) => (
            <MenuItem key={idx} item={child} />
          ))}
        </ul>
      )}
    </li>
  );
}

export default MainMenu;
